import { createContext } from "react";

export interface ToastContextType {
  toast: (message: string, type?: "error" | "success") => void;
}

export const ToastContext = createContext<ToastContextType | null>(null);
